module.exports = __webpack_public_path__ + "static/img/third.79e5105c.png";